<script setup lang="ts">
import {
  BellAlertIcon,
  CalendarDaysIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/vue/24/outline'
import { computed, type Component } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  value: number | string
  label: string
}>()

const iconsByLabel: Record<string, Component> = {
  total_alarms: BellAlertIcon,
  total_classified_alarms: CheckCircleIcon,
  total_non_classified_alarms: ExclamationTriangleIcon,
  day_with_most_alarms: CalendarDaysIcon,
}

const icon = computed(() => iconsByLabel[props.label] ?? BellAlertIcon)
</script>

<template>
  <article
    class="flex min-h-[7.5rem] items-center gap-4 border border-stroke bg-white px-4 py-4 shadow-sm transition-all duration-200 ease-out hover:-translate-y-0.5 hover:border-primary hover:shadow-md">
    <div class="min-w-0 flex-1">
      <p class="truncate font-satoshi text-sm font-medium text-gray">
        {{ t(`alarm_report.body.result.totalizers.cards.labels.${props.label}`) }}
      </p>
      <p class="mt-2 font-satoshi text-title-lg font-bold tabular-nums leading-none text-black sm:text-title-lg">
        {{ props.value }}
      </p>
    </div>

    <component :is="icon" class="h-8 w-8 shrink-0 text-primary" aria-hidden="true" />
  </article>
</template>
